import { render, staticRenderFns } from "./EffectFeedbackModal.vue?vue&type=template&id=1abe0f9e&scoped=true"
import script from "./EffectFeedbackModal.vue?vue&type=script&lang=js"
export * from "./EffectFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./EffectFeedbackModal.vue?vue&type=style&index=0&id=1abe0f9e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abe0f9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abe0f9e')) {
      api.createRecord('1abe0f9e', component.options)
    } else {
      api.reload('1abe0f9e', component.options)
    }
    module.hot.accept("./EffectFeedbackModal.vue?vue&type=template&id=1abe0f9e&scoped=true", function () {
      api.rerender('1abe0f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/PsyCounselNum/components/EffectFeedbackModal.vue"
export default component.exports